import React, { ReactElement } from 'react';
import Avatar from '@mui/material/Avatar';

const ImageAvatar: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const AVATAR_TYPE_CIRCULAR: AvatarVariant = 'circular';
  const AVATAR_TYPE_SQUARE: AvatarVariant = 'square';

  const {
    isSquare,
    text,
    link,
    className,
    children,
  } = props;

  const variant: AvatarVariant = isSquare ? AVATAR_TYPE_SQUARE : AVATAR_TYPE_CIRCULAR;

  return (
    <Avatar
      variant={variant}
      alt={text}
      src={link}
      className={className}
    >
      {children}
    </Avatar>
  );
});

export default ImageAvatar;
